exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".table thead th[data-v-195241c0]{border-bottom:1px solid #eceeef;border-top:none}", "", {"version":3,"sources":["/home/runner/work/KeepNeyeVue/KeepNeyeVue/src/components/view/TransferPending.vue"],"names":[],"mappings":"AACA,iCACE,gCAAiC,AACjC,eAAiB,CAClB","file":"TransferPending.vue","sourcesContent":["\n.table thead th[data-v-195241c0]{\n  border-bottom: 1px solid #eceeef;\n  border-top: none;\n}\n"],"sourceRoot":""}]);

// exports
